import { render } from "./Routes.vue?vue&type=template&id=fe838fbc"
import script from "./Routes.vue?vue&type=script&lang=js"
export * from "./Routes.vue?vue&type=script&lang=js"
script.render = render

export default script